import { OrganizationDTO } from '../schemas';
import { Organization } from '../types';

/**
 * Maps an Organization DTO to a Domain model.
 */
export function mapOrganizationDTOToDomain(dto: OrganizationDTO): Organization {
  const { details, ...org } = dto;
  return {
    ...(details as Record<string, string> || {}),
    ...org,
    id: dto.id || '', // Ensure ID is present for domain model
  };
}

/**
 * Maps a list of Organization DTOs to Domain models.
 */
export function mapOrganizationsDTOToDomain(dtos: OrganizationDTO[]): Organization[] {
  return dtos.map(mapOrganizationDTOToDomain);
}
